import ItemCardLandscapePreview from './itemCardLandscapePreview'

export default ItemCardLandscapePreview
